import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { Airport } from 'types';

interface Props {
  type?: 'origin' | 'destination';
  label?: string;
  placeholder?: string;
  name?: string;
  required?: boolean;
  airports?: Airport[];
}

const { Option } = Select;

export function FieldAirport(props: Props): ReactElement | null {
  const {
    type,
    placeholder,
    label,
    name,
    required = false,
    airports = LeashContent?.airports || [],
  } = props;

  const commonLabel = type === 'origin' ? 'Origin' : 'Destination';

  return (
    <Form.Item
      name={name ?? `${type}AirportId`}
      label={label ?? `${commonLabel} airport`}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <Select
        data-testid={`${type}-airport`}
        showSearch
        allowClear
        placeholder={placeholder ?? 'Select airport'}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return (
            option?.children?.join()?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
          );
        }}
      >
        {airports.map((a: Airport) => (
          <Option value={a.id} key={a.id}>
            {a.name} ({a.code})
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}
